export enum Availability {
  Morning,
  AfterNoon,
  Evening,
  Night,
}
